module.exports = __webpack_public_path__ + "static/media/12.aa04b8b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/12.jpg
// module id = 929
// module chunks = 0